module.exports = __webpack_public_path__ + "img/logo.234fe13b.svg";